<template>
  <Drawer width="800" title="销售合同" v-model="drawerOpened">
    <div>lala</div>
  </Drawer>
</template>

<script>
export default {
  name: "SalesContractDetailDrawer",
  data() {
    return {
      drawerOpened: false,
    };
  },
  methods: {
    async openDrawer() {
      this.drawerOpened = true;
    },
  },
};
</script>
<style lang="stylus" scoped></style>